var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.social),function(ref,i){
var text = ref.text;
var link = ref.link;
var icon = ref.icon;
return _c('v-btn',{key:i,staticClass:"ml-2",attrs:{"href":link,"target":"_blank","min-width":"auto","color":"white","title":text,"depressed":"","rounded":"","icon":""}},[_c('v-icon',{attrs:{"size":"24"}},[_vm._v(_vm._s(icon))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }